import type { ZudokuConfig } from "zudoku";
import { ZudokuPlugin } from "zudoku";

import { RngSchemaBody } from "./src/rng-schema-plugin.js";
import { ResponseHeadersSlot } from "./src/response-headers-slot.js";

// const commonPlugin: ZudokuPlugin = {
  // getHead: () => <link rel="stylesheet" href="/custom-styles.css" />
// };

const config: ZudokuConfig = {
  // plugins: [commonPlugin],
  slots: {
    "schema-view-body": RngSchemaBody,
    "response-header": ResponseHeadersSlot,
  },
  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 3,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
  metadata: {
    defaultTitle: "Keepit API Documentation",
    favicon: "https://www.keepit.com/Assets/Grx/favicon.svg",
    title: "Keepit API Documentation"
  },
  site: {
    logo: {
      src: { light: "/keepit_logo.svg", dark: "/keepit_logo.svg" },
      alt: "Keepit",
      width: "130px",
    },
    showPoweredBy: false
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          items: [
            "intro",
            "authentication",
            "apiversions",
            "apiheaders",
            "apipermissions",
            "tokens-primary-secondary"
          ],
        },
        {
          type: "category",
          label: "Guides and Articles",
          items: [
            "how-to-set-up-messages-and-notifications",
            "How-to--BulkRestoreDeletedItems",
            "How-to--RestoreItem",
          ],
        },
        {
          type: "category",
          label: "Reference",
          items: [
            "resource-names",
            "connector-types",
            "escape-masking",
            "acl-names",
            "product-property-keys",
          ],
        },
      ],
    },
    { type: "link", to: "/api/accounts",        label: "Accounts API" },
    { type: "link", to: "/api/products",         label: "Products API" },
    { type: "link", to: "/api/data-protection",  label: "Data Protection API" },
    { type: "link", to: "/api/reporting",        label: "Reporting API" },
  ],
  redirects: [{ from: "/", to: "/intro" }],
  apis: [
    {
      type: "file",
      input: "./generated/accounts.yaml",
      path: "/api/accounts",
      options: { disablePlayground: true },
    },
    {
      type: "file",
      input: "./generated/products.yaml",
      path: "/api/products",
      options: { disablePlayground: true },
    },
    {
      type: "file",
      input: "./generated/data-protection.yaml",
      path: "/api/data-protection",
      options: { disablePlayground: true },
    },
    {
      type: "file",
      input: "./generated/reporting.yaml",
      path: "/api/reporting",
      options: { disablePlayground: true },
    },
  ],
};

export default config;
